@if (isLoadingProfile) {
<div class="max-w-4xl mx-auto">
  <div class="bg-blue-950/50 sm:h-48 h-30 w-full rounded-b-lg"></div>

  <div class="px-6 py-4">
    <div class="flex sm:flex-row flex-col sm:items-start items-center sm:gap-6 gap-4">
      <div class="bg-gray-300 dark:bg-blue-950 h-30 w-30 sm:h-40 sm:w-40 rounded-full -mt-20"></div>

      <div class="flex flex-col space-y-3 sm:items-start items-center">
        <div class="skeleton rounded-lg h-8 w-64"></div>
        <div class="skeleton rounded-lg h-4 w-32"></div>
      </div>
    </div>
  </div>
</div>
} @else {
<!-- Perfil Cargado -->
<div
  class="bg-linear-to-br from-blue-800/90 to-cyan-800/90 dark:from-purple-800/40 dark:to-blue-800/40 mb-4 max-w-4xl mx-auto rounded-b-lg overflow-hidden">
  <div class="banner-section sm:h-48 h-30">
    <img [ngSrc]="safeBannerUrl" (error)="handleImageError($event, 'banner')" width="896" height="192" priority
      class="bg-gray-900 object-cover w-full h-full" [alt]="'ACCOUNT.BANNER_ALT' | translate">
  </div>

  <div class="profile-content flex sm:flex-row flex-col items-center sm:items-start px-6 py-4 gap-4 sm:gap-6 relative">
    <div class="profile-image-section -mt-20 justify-center shrink-0">
      <img [ngSrc]="safeProfilePictureUrl" (error)="handleImageError($event, 'profile')" width="160" height="160"
        class="h-32 w-32 sm:h-40 sm:w-40 rounded-full border-4 border-white dark:border-gray-900 bg-gray-200 object-cover"
        [alt]="'ACCOUNT.PROFILE_ALT' | translate">
    </div>

    <div class="flex w-full">
      <div class="flex flex-col w-full sm:items-start items-center">
        <div class="flex justify-center sm:justify-between w-full">
          <div class="flex items-center gap-4">
            <h1 class="text-3xl font-bold text-white truncate sm:max-w-100 max-w-80">
              {{ user?.name }}
            </h1>
            @if (currentUserId() !== user?.id) {
            <button [disabled]="followOperationInProgress" (click)="toggleFollow()"
              class="sm:flex hidden px-4 py-1 rounded-full cursor-pointer transition-colors" [ngClass]="{
                    'bg-linear-to-r from-emerald-400/80 to-yellow-600 dark:from-cyan-400/60 dark:to-cyan-700/80 hover:bg-white/60 text-white': !isFollowing,
                    'bg-gray-900 text-gray-200': isFollowing
                  }">
              {{
              followOperationInProgress
              ? '...'
              : (isFollowing ? ('ACCOUNT.FOLLOWING' | translate) : ('ACCOUNT.FOLLOW' | translate))
              }}
            </button>

            @if (isLoggedIn) {
            <button (click)="openReportModal()"
              class="bg-red-800 hover:bg-white/60 text-white sm:flex hidden items-center justify-center p-2 rounded-full transition-all cursor-pointer"
              [title]="'ACCOUNT.REPORT_USER' | translate">
              <span class="icon-[mingcute--alert-line] text-lg"></span>
            </button>
            }
            }
          </div>

          <div class="gap-1 sm:gap-2 flex items-center relative">
            <div class="hidden sm:flex gap-2 items-center">
              @if (user.profile?.youtube_link) {
              <a [href]="user.profile.youtube_link" target="_blank" class="cursor-pointer">
                <img src="social_media/yt.svg" class="w-7">
              </a> }
              @if (user.profile?.facebook_link) {
              <a [href]="user.profile.facebook_link" target="_blank" class="cursor-pointer">
                <img src="social_media/fc.svg" class="w-7">
              </a> }
              @if (user.profile?.x_link) {
              <a [href]="user.profile.x_link" target="_blank" class="cursor-pointer">
                <img src="social_media/x.svg" class="w-7">
              </a> }
              @if (user.profile?.discord_link) {
              <a [href]="user.profile.discord_link" target="_blank" class="cursor-pointer">
                <img src="social_media/discord.svg" class="w-7">
              </a> }
            </div>

            <button class="hidden dropdown relative group items-center px-2 py-1 rounded bg-gray-900">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>

              <div
                class="dropdown-content grid-row absolute rounded-lg shadow-lg bg-black text-white invisible opacity-0 transition-all duration-300 transform translate-y-2 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 z-1 right-0">
                @if (user.profile?.youtube_link) {
                <a [href]="user.profile.youtube_link" target="_blank"
                  class="flex items-center gap-2 py-1 px-2 hover:bg-gray-800 rounded">
                  <img src="social_mediayt.svg" class="dropdown-item w-6">
                </a> }
                @if (user.profile?.facebook_link) {
                <a [href]="user.profile.facebook_link" target="_blank"
                  class="flex items-center gap-2 py-1 px-2 hover:bg-gray-800 rounded">
                  <img src="social_media/fc.svg" class="dropdown-item w-6">
                </a> }

                @if (user.profile?.x_link) {
                <a [href]="user.profile.x_link" target="_blank"
                  class="flex items-center gap-2 py-1 px-2 hover:bg-gray-800 rounded">
                  <img src="social_media/x.svg" class="dropdown-item w-6">
                </a> }

                @if (user.profile?.discord_link) {
                <a [href]="user.profile.discord_link" target="_blank"
                  class="flex items-center gap-2 py-1 px-2 hover:bg-gray-800 rounded">
                  <img src="social_media/discord.svg" class="dropdown-item w-6">
                </a> }
              </div>
            </button>
          </div>
        </div>
        <p class="text-sm text-gray-300 dark:text-gray-400">
          &#64;{{ user?.username }}
        </p>
      </div>
    </div>
  </div>

  @if (currentUserId() !== user?.id) {
  <div class="profile-content sm:hidden flex flex-col justify-center px-6 pb-4 relative">
    <button [disabled]="followOperationInProgress" (click)="toggleFollow()"
      class="w-full py-2 rounded-full cursor-pointer transition-colors" [ngClass]="{
              'bg-cyan-700 hover:bg-white/60 text-white font-bold': !isFollowing,
              'bg-gray-900 text-gray-200': isFollowing
            }">
      {{
      followOperationInProgress
      ? '...'
      : (isFollowing ? ('ACCOUNT.FOLLOWING' | translate) : ('ACCOUNT.FOLLOW' | translate))
      }}
    </button>
    @if (isLoggedIn) {
    <button (click)="openReportModal()"
      class="bg-red-800 hover:bg-white/60 text-white w-full mt-4 py-2 rounded-full cursor-pointer transition-all flex items-center justify-center gap-2 text-sm font-bold uppercase">
      <span class="icon-[mingcute--alert-line] text-lg"></span>
      {{ 'ACCOUNT.REPORT_USER' | translate }}
    </button>
    }
  </div>
  }
</div>
}

<!-- Sección de Información (se carga después del perfil) -->
<div class="text-gray-700 dark:text-white max-w-4xl mx-auto justify-between flex sm:gap-4 sm:flex-row flex-col">
  @if (isLoadingStats) {
  <div class="w-full p-4 sm:bg-blue-950/50 rounded-lg space-y-3">
    <div class="skeleton rounded-lg h-6 w-1/4"></div>
    <div class="skeleton rounded-lg h-4 w-full"></div>
    <div class="skeleton rounded-lg h-4 w-3/4"></div>
  </div>
  <div class="w-full p-4 sm:bg-blue-950/50 rounded-lg space-y-3">
    <div class="skeleton rounded-lg h-6 w-1/4"></div>
    <div class="skeleton rounded-lg h-4 w-3/4"></div>
    <div class="skeleton rounded-lg h-4 w-2/4"></div>
    <div class="skeleton rounded-lg h-4 w-3/4"></div>
  </div>
  } @else {
  <div
    class="sm:bg-white dark:sm:bg-blue-950/50 sm:border sm:border-gray-200 sm:dark:border-0 w-full p-4 rounded-lg space-y-2 min-w-0">
    <h2 class="text-xl font-bold">{{ 'ACCOUNT.ABOUT_ME' | translate }}</h2>
    <h1 class="text-gray-400 cursor-default wrap-anywhere"
      [innerHTML]="(user.profile?.bio || ('ACCOUNT.NO_BIO' | translate)) | emojiParser:'image':user.is_pro"></h1>
  </div>
  <div
    class="sm:bg-white dark:sm:bg-blue-950/50 sm:border sm:border-gray-200 sm:dark:border-0 w-full p-4 rounded-lg space-y-2">
    <h2 class="text-xl font-bold">{{ 'ACCOUNT.MORE_INFO' | translate }}</h2>
    <div class="text-gray-400 flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
        <path fill="currentColor"
          d="M336 256c-20.56 0-40.44-9.18-56-25.84c-15.13-16.25-24.37-37.92-26-61c-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52c15.47 16.62 23 39.22 21.26 63.63c-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256m131.83 176H204.18a27.71 27.71 0 0 1-22-10.67a30.22 30.22 0 0 1-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05c31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 0 1-5.32 25.78A27.68 27.68 0 0 1 467.83 432M147 260c-35.19 0-66.13-32.72-69-72.93c-1.42-20.6 5-39.65 18-53.62c12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52c-2.87 40.2-33.8 72.91-68.93 72.91m65.66 31.45c-17.59-8.6-40.42-12.9-65.65-12.9c-29.46 0-58.07 7.68-80.57 21.62c-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 0 0 4.79 23.36A25.32 25.32 0 0 0 41.72 400h111a8 8 0 0 0 7.87-6.57c.11-.63.25-1.26.41-1.88c8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 0 0-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89" />
      </svg>
      <p>{{ 'ACCOUNT.FOLLOWERS' | translate:{ count: user.followers_count || 0 } }}</p>
    </div>
    <div class="text-gray-400 flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
      </svg>
      <p>{{ joinedDate ? ('ACCOUNT.JOINED_ON' | translate:{ date: joinedDate }) : ('ACCOUNT.JOINED_RECENTLY' |
        translate) }}</p>
    </div>
    <div class="text-gray-400 flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="m18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z" />
      </svg>
      <p>{{ 'ACCOUNT.CREATIONS' | translate:{ count: user.posts_count || 0 } }}</p>
    </div>
  </div>
  }
</div>

<!-- Sección de Publicaciones (se carga al final) -->
<div class="max-w-4xl mx-auto p-4">
  <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
    <h2 class="text-gray-700 dark:text-white text-xl font-bold">{{ 'ACCOUNT.SECTION_CREATIONS' | translate }}</h2>

    <!-- Filtro de ordenación (estilo YouTube) -->
    @if (!isLoadingProjects) {
    <div
      class="bg-white dark:bg-blue-950/60 sm:border sm:border-gray-200 sm:dark:border-0 flex items-center rounded-lg p-1 gap-1">
      <button (click)="setSort('newest')" [attr.aria-pressed]="sortOption === 'newest'"
        [class]="sortOption === 'newest'
            ? 'px-3 py-1.5 rounded-md text-sm font-medium bg-blue-700 text-white transition-all duration-200'
            : 'px-3 py-1.5 rounded-md text-sm font-medium text-gray-400 hover:text-gray-700 dark:hover:text-white transition-all duration-200'">
        {{ 'ACCOUNT.SORT_NEWEST' | translate }}
      </button>
      <button (click)="setSort('liked')" [attr.aria-pressed]="sortOption === 'liked'"
        [class]="sortOption === 'liked'
            ? 'px-3 py-1.5 rounded-md text-sm font-medium bg-blue-700 text-white transition-all duration-200'
            : 'px-3 py-1.5 rounded-md text-sm font-medium text-gray-400 hover:text-gray-700 dark:hover:text-white transition-all duration-200'">
        {{ 'ACCOUNT.SORT_LIKED' | translate }}
      </button>
      <button (click)="setSort('oldest')" [attr.aria-pressed]="sortOption === 'oldest'"
        [class]="sortOption === 'oldest'
            ? 'px-3 py-1.5 rounded-md text-sm font-medium bg-blue-700 text-white transition-all duration-200'
            : 'px-3 py-1.5 rounded-md text-sm font-medium text-gray-400 hover:text-gray-700 dark:hover:text-white transition-all duration-200'">
        {{ 'ACCOUNT.SORT_OLDEST' | translate }}
      </button>
    </div>
    }
  </div>

  <div class="relative group">
    <div #scrollContainer class="scroll-container flex overflow-x-auto scrollbar-hide snap-x snap-mandatory gap-4"
      (scroll)="updateScrollButtons()" (scrollend)="updateScrollButtons()">
      @if (!isLoadingProjects) {
      @for (project of projects; track project.idform) {
      <div class="project-card" (click)="goToForm(project)">
        <div class="image-container relative overflow-hidden">
          <img [ngSrc]="getSafeThumbnailUrl(project)" width="336" height="189"
            (error)="handleImageError($event, 'project')" [alt]="'ACCOUNT.THUMBNAIL_ALT' | translate"
            class="project-image object-cover" />
          @if (project.items_count != null) {
          <div
            class="absolute top-2 right-2 bg-black/60 text-white text-xs font-bold px-2 py-1 rounded-md backdrop-blur-sm">
            {{ project.items_count }} items
          </div>
          }
        </div>
        <div class="flex px-4 py-2 justify-between">
          <div>
            <h3 class="text-lg font-bold sm:truncate">{{ project.nameform }}</h3>

            <div class="flex justify-between items-center">
              <p class="text-xs font-semibold" [ngClass]="getProjectTypeColorClass(project.tipoform)">
                {{ getProjectTypeLabel(project.tipoform) }}
              </p>
            </div>
          </div>
          <div class="flex items-center text-gray-300 gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="m20.27 16.265l.705-4.08a1.666 1.666 0 0 0-1.64-1.95h-5.182a.833.833 0 0 1-.821-.969l.663-4.045a4.8 4.8 0 0 0-.09-1.973a1.64 1.64 0 0 0-1.093-1.137l-.145-.047a1.35 1.35 0 0 0-.993.068c-.34.164-.588.463-.68.818l-.476 1.834a7.6 7.6 0 0 1-.656 1.679c-.416.777-1.058 1.4-1.725 1.975l-1.44 1.24a1.67 1.67 0 0 0-.572 1.406l.813 9.393A1.666 1.666 0 0 0 8.596 22h4.649c3.481 0 6.452-2.426 7.024-5.735" />
              <path fill="currentColor" fill-rule="evenodd"
                d="M2.968 9.485a.75.75 0 0 1 .78.685l.97 11.236a1.237 1.237 0 1 1-2.468.107V10.234a.75.75 0 0 1 .718-.749"
                clip-rule="evenodd" opacity="0.5" />
            </svg>
            @if (project.likes_count > 0) {
            <span class="font-semibold tabular-nums leading-none">{{ project.likes_count }}</span>
            }
          </div>
        </div>
      </div>
      }
      } @else {
      @for (item of [1,2,3,4]; track $index) { <!-- Puedes ajustar el número de skeletons (ej. [1,2,3,4,5]) -->
      <div class="group snap-start cursor-pointer shrink-0 w-70 bg-blue-950/50 rounded-lg">
        <div class="image-container relative pt-[56.25%] overflow-hidden">
          <div class="rounded-lg absolute top-0 left-0 w-full h-full"></div>
        </div>
        <div class="mt-3 mx-4">
          <div class="h-6 skeleton rounded w-3/4 mb-2"></div>
          <div class="flex items-center mt-2 mb-3">
            <div class="ml-2">
              <div class="h-4 skeleton rounded w-24"></div>
            </div>
          </div>
        </div>
      </div>
      }
      }
    </div>

    @if (showLeftArrow) {
    <button (click)="scroll(-1)"
      class="absolute left-2 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-opacity duration-300 z-1 shadow-lg"
      [attr.aria-label]="'ACCOUNT.SCROLL_LEFT' | translate">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button> }

    @if (showRightArrow) {
    <button (click)="scroll(1)"
      class="absolute right-2 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-opacity duration-300 z-1 shadow-lg"
      [attr.aria-label]="'ACCOUNT.SCROLL_RIGHT' | translate">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button> }
  </div>
</div>